export default __webpack_public_path__ + "img/engine-tab.2e8b4c2a.png";